/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.addEventListener("load", (event) => {
  function handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const metaBarHeight = document.querySelector(
      ".boost-sd__toolbar-item.boost-sd__toolbar-item--sorting"
    ).offsetHeight;
    const productListOffsetTop = document.querySelector(
      ".boost-sd__toolbar-container"
    ).offsetTop;

    if (scrollTop + metaBarHeight > productListOffsetTop) {
      document
        .querySelector(".boost-sd__toolbar")
        .classList.add("is-toolbar-scroll");
    } else {
      document
        .querySelector(".boost-sd__toolbar")
        .classList.remove("is-toolbar-scroll");
    }
  }

  window.addEventListener("scroll", handleScroll);
});

// document.addEventListener("DOMContentLoaded", () => {
//   const productList = document.querySelector(
//     ".boost-sd__filter-product-list.boost-sd__filter-product-list--ready"
//   );

//   if (!productList) {
//     console.error("Product list not found!");
//   } else {
//     const config = { childList: true };

//     const callback = (mutationList, observer) => {
//       for (const mutation of mutationList) {
//         if (mutation.target === productList) {
//           const product_element = mutation.target.querySelectorAll(
//             ".boost-sd__product-item"
//           );

//           product_element.forEach((product) => {
//             const observer = new IntersectionObserver(handleIntersect);

//             function handleIntersect(entries) {
//               entries.forEach((entry) => {
//                 if (!entry.isIntersecting) return;

//                 const product = entry.target;

//                 const swiper_container = product.querySelector(
//                   ".js-mainvisual-swiper"
//                 );
//                 const swiper_container_child =
//                   product.querySelector(".js-swiper-child");
//                 const swiper_thumbail = product.querySelector(
//                   ".js-swiper-thumbnail"
//                 );
//                 const swiper_thumbail_child = product.querySelectorAll(
//                   ".js-swiper-child .child-slider"
//                 );

//                 if (swiper_container && !swiper_container.swiper) {
//                   new Swiper(swiper_container, {
//                     loop: false,
//                     slidesPerView: 1,
//                     spaceBetween: 0,
//                     pagination: {
//                       el: swiper_container.querySelector(
//                         ".swiper-pagination.swiper-pagination-parent"
//                       ),
//                       type: "progressbar",
//                     },
//                   });
//                 }

//                 if (
//                   swiper_container_child &&
//                   swiper_thumbail &&
//                   !swiper_thumbail.swiper
//                 ) {
//                   let swiperThumnail;

//                   swiperThumnail = new Swiper(swiper_thumbail, {
//                     loop: false,
//                     slidesPerView: 5,
//                     freeMode: true,
//                     watchSlidesProgress: true,
//                   });

//                   new Swiper(swiper_container_child, {
//                     loop: false,
//                     slidesPerView: 1,
//                     allowTouchMove: false,
//                     effect: "fade",
//                     thumbs: {
//                       swiper: swiperThumnail,
//                     },
//                   });
//                 }

//                 if (swiper_thumbail_child.length > 0) {
//                   swiper_thumbail_child.forEach((child) => {
//                     if (!child.swiper) {
//                       new Swiper(child, {
//                         loop: false,
//                         slidesPerView: 1,
//                         spaceBetween: 0,
//                         pagination: {
//                           el: child.querySelector(
//                             ".swiper-pagination.swiper-pagination-child"
//                           ),
//                           type: "progressbar",
//                         },
//                       });
//                     }
//                   });
//                 }
                
//                 observer.unobserve(product)
//               });
//             }

//             observer.observe(product);
//           });
//         }
//       }
//     };

//     const observer = new MutationObserver(callback);

//     try {
//       observer.observe(productList, config);
//     } catch (error) {
//       console.error("Observer failed");
//     }
//   }
// });
